// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--ov5Kw";
export var footerLinks = "footer-module--footerLinks--vj29S";
export var footerMenu = "footer-module--footerMenu--Bo5xd";
export var mainFooter = "footer-module--mainFooter--hvWWI";
export var preFooter = "footer-module--preFooter--yk1wT";